import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { sendEmailInvite, requestInviteLink } from 'reducers/fundingReport/reducer';
import { makeSelectUserEmail } from 'reducers/user/selectors';
import { makeSelectInviteLink } from 'reducers/fundingReport/selectors';

import InviteClientModal from '../../components/InviteClientModal/InviteClientModal';

const mapStateToProps = createStructuredSelector({
  email: makeSelectUserEmail(),
  inviteLink: makeSelectInviteLink(),
});

const mapDispatchToProps = (dispatch) => ({
  sendEmailInvite: (payload) =>
    new Promise((resolve, reject) => dispatch(sendEmailInvite(payload, { resolve, reject }))),
  requestInviteLink: () => dispatch(requestInviteLink()),
});

export default connect(mapStateToProps, mapDispatchToProps)(InviteClientModal);
